import { Users } from 'lucide-react'

const Community = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900 pt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center py-12">
          <Users className="w-16 h-16 text-green-400 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-white mb-2">Community Hub</h1>
          <p className="text-gray-400">Connect with fellow commanders across the galaxy</p>
          <p className="text-gray-500 mt-4">Coming Soon...</p>
        </div>
      </div>
    </div>
  )
}

export default Community